'use client'

import { SessionProvider } from 'next-auth/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { AIManager } from '@/components/ai/AIManager'
import { getBrowserQueryClient } from '@/lib/query-client'

export function Providers({ children }: { children: React.ReactNode }) {
  // Get singleton query client for browser
  const queryClient = getBrowserQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider
        basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
        // Refetch session every 10 minutes to keep tokens fresh (reduced from 4 minutes)
        // This triggers the JWT callback which handles token refresh
        refetchInterval={10 * 60}
        // Don't refetch on window focus to reduce API calls
        refetchOnWindowFocus={false}
      >
        <AIProvider>
        {children}
        <ToastProvider />
        <CommandPalette />
          <AIManager />
        </AIProvider>
      </SessionProvider>
      {/* React Query DevTools - only in development */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
